// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "@tailwindplus/elements";
import "./controllers";
import "./channels";
import "./src";

import "trix";
import "@rails/actiontext";
require("@rails/activestorage").start();
import ahoy from "ahoy.js";
